import maleApprenticeAvatar from '../assets/images/avatar/avatar-a-m.svg'
import femaleApprenticeAvatar from '../assets/images/avatar/avatar-a-w.svg'
import diverseAvatar from '../assets/images/avatar/avatar-div.svg'
import maleAdultAvatar from '../assets/images/avatar/avatar-e-m.svg'
import femaleAdultAvatar from '../assets/images/avatar/avatar-e-w.svg'
import neutralAvatar from '../assets/images/avatar/avatar-na.svg'
import {SalutationCt, UserAccountType} from '../model/enums/enums'
import {Person} from '../model/person.model'

/**
 * returning the svg of the avatar. it is different for gender and account type (eg adult or not adult)
 * @param {SalutationCt | undefined} salutation
 * @param {UserAccountType | undefined} accountType
 * @returns {svg}
 */
export const getUserAvatar = (salutation: SalutationCt | undefined, accountType: UserAccountType | undefined) => {

	if (salutation === undefined || salutation === SalutationCt.NoSpecification) {
		return neutralAvatar
	}

	if (salutation === SalutationCt.Diverse) {
		return diverseAvatar
	}

	if (accountType === UserAccountType.Apprentice) {
		if (salutation === SalutationCt.Ms) {
			return femaleApprenticeAvatar
		}
		return maleApprenticeAvatar
	}

	if (salutation === SalutationCt.Ms) {
		return femaleAdultAvatar
	}
	return maleAdultAvatar
}

/**
 * returns the image path of the person or default avatar if no image is present
 * @param {Person | undefined} person
 * @returns {string}
 */
export const getUserAvatarSrc = (person: Person | undefined): string  => {

	if (person?.profile_image_thumbnail_ref) {
		return person.profile_image_thumbnail_ref
	}
	return getUserAvatar(person?.salutation, person?.user_account_type)
}

export const getUserBigAvatarSrc = (person: Person | undefined) => {
	if (person?.profile_image_ref) {
		return person?.profile_image_ref
	}
	return getUserAvatar(person?.salutation, person?.user_account_type)
}

